const env = {
  appVersion: process.env.REACT_APP_VERSION || "1.0.0",
  mode: process.env.REACT_APP_MODE || "development",
  appUrl: process.env.REACT_APP_URL || "http://localhost:3005",
  apiUrl: process.env.REACT_APP_API_URL || "http://localhost:8002",
  signupOrigin: process.env.REACT_APP_SIGNUP_ORIGIN || "http://localhost:3002",
  accountOrigin: process.env.REACT_APP_ACCOUNT_ORIGIN || "http://localhost:3003",
  pixelProxyOrigin: process.env.REACT_APP_PIXEL_PROXY_ORIGIN || "http://localhost:8011",
  pubNubSubscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY || "",
  firebaseAppName: process.env.REACT_APP_FIREBASE_APP_NAME || "",
  mixpanelId: process.env.REACT_APP_MIXPANEL_ID || "",
  encryption: {
    publicKey: process.env.REACT_APP_PUBLIC_KEY || "",
    privateKey: process.env.REACT_APP_PRIVATE_KEY || "",
  },
  firebaseConfig: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
    messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID || "",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  },
};

export default env;
